<template>
  <game-template :success="success">
    <template v-if="stepIndex > 0 &&!finishedFirstStage " v-slot:head>
      <p class="title">
        {{ stageInfos.label }}
      </p>
      <div class="step-label-wrapper">
        <p class="step-index">
          {{ stepIndex }}
        </p>
        <p class="step-label">
          {{ stageStep.label }}
        </p>
      </div>
    </template>
    <template v-else-if="finishedFirstStage && stageIndex === 0" v-slot:head>
      <p class="title">
        Félicitations ! Vous avez saisi les congés de Didier.
      </p>
      <button class="button" @click="nextStage">Saisir une absence maladie</button>
    </template>
    <template v-else-if="stepIndex > 0 && stageIndex > 0 && !finished" v-slot:head>
      <p class="title">
        {{ stageInfos.label }}
      </p>
      <div class="step-label-wrapper">
        <p class="step-index">
          {{ stepIndex }}
        </p>
        <p class="step-label">
          {{ stageStep.label }}
        </p>
      </div>
    </template>
    <template v-else-if="finished" v-slot:head>
      <p class="title">
        Félicitations ! Vous avez suivi toutes les étapes pour déclarer une absence.
      </p>
      <button class="button" @click="next">Continuer</button>
    </template>
    <template v-slot:content>
      <div class="saisie-absence-game">
        <popup v-if="stageInfos.name === 'conges-didier' && !finishedFirstStage" ref="conges-popup"
          v-on:closed="popupClosed"
          title="Vous avez une demande de congés !"
          :auto-open="true">
          <template v-slot:button>
            <button class="popup-button">Revoir la demande de Didier</button>
          </template>
          <template v-slot:content>
            <div class="popup-wrapper">
              <div class="mail-content">
                Bonjour, <br>
                Je voudrais poser des congés payés du mercredi 1er juillet au matin jusqu'au 2 à midi ainsi que le vendredi 3 après-midi et le samedi 4.
                <br><br>
                Cordialement, <br>
                <strong>Didier</strong>
              </div>
              <button @click="closePopup('conges-popup')" class="button">Saisir l'absence dans l'interface GTA</button>
            </div>
          </template>
        </popup>
        <popup v-if="stageInfos.name === 'maladie-didier'" ref="maladie-popup"
          v-on:closed="popupClosed"
          title="Vous avez reçu un arrêt maladie !"
          :auto-open="true">
          <template v-slot:button>
            <button class="popup-button">Revoir l’arrêt maladie <br> de Didier</button>
          </template>
          <template v-slot:content>
            <div class="popup-wrapper">
              <div class="mail-content">
                Bonjour, <br>
                Je suis allé chez mon médecin hier, lundi 13/07 après le travail. Il m’a arrêté jusqu’au samedi 18/07.
                <br><br>
                Ci-joint mon arrêt maladie. <br>
                Cordialement,<br>
                <strong>Didier</strong>
              </div>
              <button @click="closePopup('maladie-popup')" class="button">Saisir l'absence dans l'interface GTA</button>
            </div>
          </template>
        </popup>
        <div v-show="stageStep.name !== 'popup'" class="gta-wrapper">
          <div @click="svgClick" class="svg-wrapper" ref="svg" v-html="require(`../assets/gta-game/${stageInfos.image}.svg?inline`)">
          </div>
        </div>
      </div>
    </template>
  </game-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'
import Popup from '@shared/components/Popup'

export default {
  name: 'SaisieAbsenceGame',
  mixins: [stepMixin],
  components: {
    Popup
  },
  data () {
    return {
      stages: ['conges-didier', 'maladie-didier'],
      stagesInfos: [
        {
          name: 'conges-didier',
          image: 'absence-conges',
          label: 'Cliquez au bon endroit pour saisir les congés de Didier',
          steps: [
            {
              name: 'popup'
            },
            {
              name: 'planing',
              label: 'Ouvrir le "planning collectif"',
              clickableZone: 'hint-1',
              item: 'item-1'
            },
            {
              name: 'periode',
              label: 'Sélectionner la période concernée par l\'absence',
              clickableZone: 'hint-2',
              item: 'item-2'
            },
            {
              name: 'raccourci',
              label: 'Cliquer sur l\'onglet "Raccourcis"',
              clickableZone: 'hint-3',
              item: 'item-3'
            },
            {
              name: 'code-absence',
              label: 'Sélectionner le code absence correspondant',
              clickableZone: 'hint-4',
              item: 'item-4'
            },
            {
              name: 'pose-conge',
              label: 'Poser le congés',
              clickableZone: 'hint-5',
              item: 'item-5'
            },
            {
              name: 'save',
              label: 'Enregistrer',
              clickableZone: 'hint-6',
              item: 'item-6'
            }
          ]
        },
        {
          name: 'maladie-didier',
          image: 'absence-maladie',
          label: 'Cliquez au bon endroit pour saisir l’absence maladie de Didier',
          steps: [
            {
              name: 'popup'
            },
            {
              name: 'planing',
              label: 'Ouvrir le "planning collectif"',
              clickableZone: 'hint-1',
              item: 'item-1'
            },
            {
              name: 'periode',
              label: 'Sélectionner la période concernée par l\'absence',
              clickableZone: 'hint-2',
              item: 'item-2'
            },
            {
              name: 'raccourci',
              label: 'Cliquer sur l\'onglet "Raccourcis"',
              clickableZone: 'hint-3',
              item: 'item-3'
            },
            {
              name: 'code-absence',
              label: 'Sélectionner le code absence correspondant',
              clickableZone: 'hint-4',
              item: 'item-4'
            },
            {
              name: 'pose-conge',
              label: 'Poser la maladie sur les jours concernés',
              clickableZone: 'hint-5',
              item: 'item-5'
            },
            {
              name: 'save',
              label: 'Enregistrer',
              clickableZone: 'hint-6',
              item: 'item-6'
            }
          ]
        }
      ],
      stageIndex: this.$store.state.absenceGameStep,
      stepIndex: 0,
      finishedFirstStage: false,
      finished: false
    }
  },
  computed: {
    stage () {
      return this.stages[this.stageIndex]
    },
    stageInfos () {
      return this.stagesInfos.filter(infos => infos.name === this.stage)[0]
    },
    stageStep () {
      return this.stageInfos.steps[this.stepIndex]
    },
    success () {
      return (this.stageIndex === 1 && this.finished) ||
        (this.finishedFirstStage && this.stepIndex === this.stageInfos.steps.length - 1 && this.stageIndex === 0)
    }
  },
  methods: {
    nextStage () {
      if (this.stageIndex < this.stages.length - 1) {
        this.stageIndex++
        this.$store.commit('setAbsenceGameStep', this.stageIndex)
        this.stepIndex = 0
      } else {
        this.$store.commit('setAbsenceGameFinished', true)
        this.finished = true
      }
    },
    nextStep () {
      if (this.stepIndex < this.stageInfos.steps.length - 1) {
        this.stepIndex++
      } else {
        if (this.stageIndex === 0) {
          this.finishedFirstStage = true
        } else {
          this.nextStage()
        }
      }
    },
    closePopup (ref) {
      this.$refs[ref].togglePopup()
    },
    popupClosed () {
      if (this.stepIndex === 0) {
        this.stepIndex++
      }
    },
    svgClick (evt) {
      const goodZoneClick = evt.target.classList.contains(this.stageStep.clickableZone)
      if (goodZoneClick) {
        this.$refs.svg.querySelector('.' + this.stageStep.item).classList.add('activ')
        this.nextStep()
      } else {
        const overlay = this.$refs.svg.querySelector('.overlay')
        overlay.classList.add('visible')
        window.setTimeout(() => {
          overlay.classList.remove('visible')
        }, 200)
      }
    }
  }
}
</script>

<style lang="scss">
.step-label-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 5px;
  .step-index {
    width: 40px;
    height: 40px;
    background-color: $secondary-color;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 1.2rem;
    border-radius: 50%;
    margin-right: 15px;
  }
  .step-label {
    background-color: #fff;
    border-radius: $radius-sm;
    padding: 15px 40px;
    font-weight: 700;
  }
}
.saisie-absence-game {
  position: relative;
  .popup-button {
    position: absolute;
    z-index: 2;
    right: 10px;
    top: 10px;
  }
  .popup-wrapper {
    .mail-content {
      background-color: $background-color;
      padding: 20px;
      text-align: left;
      font-family: $secondary-font;
      font-size: 0.9rem;
      margin: 40px 100px 20px 100px;
      border-radius: $radius-sm;
      strong {
        font-family: $primary-font;
        font-size: 1.1rem;
      }
    }
    .button {
      margin: 0 auto;
    }
  }
  .svg-wrapper {
    max-width: 100%;
    svg {
      min-height: 500px;
      max-width: 100%;
      text {
        font-family: $primary-font;
        font-weight: 700;
      }
      .overlay {
        transition: opacity 0.3s;
        opacity: 0;
        &.visible {
          opacity: .4;
        }
      }
      .item {
        .hint {
          cursor: pointer;
          &:hover {
            rect {
              transition: opacity 0.3s ease-out;
              opacity: 0;
            }
          }
        }
        .bubble {
          transition: opacity 0.3s ease-out;
          opacity: 0;
        }
        &.activ {
          .bubble {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
